import React, { useRef, useState } from 'react';
import { Container, Form, Button, Card, Row, Col } from 'react-bootstrap';
import { jsPDF } from 'jspdf';
import axios from 'axios'; // Import axios for API calls

const Cvthemeone = () => {
  const componentRef = useRef();

  const [cvData, setResume] = useState({
    name: 'Shubham Mukati',
    title: 'Software Engineer',
    phoneNumber: '7247643764',
    email: 'shubham.mukati@parkhya.net',
    location: 'Indore, India',
    summary: 'Experienced software engineer with a passion for developing innovative applications.',
    experience: [
      {
        title: 'Software Developer',
        company: 'Parkhya Solution Pvt. Ltd.',
        startDate: '2024-12-16',
        endDate: 'till now',
        description: 'Worked on building scalable web applications using React and Node.js.',
      },
    ],
    education: [
      {
        degree: 'B.Tech (CSE)',
        institution: 'SAGE University, Indore',
        startDate: '2019',
        endDate: '2023',
      },
    ],
    projects: [
      {
        title: 'Balloon Decoration',
        description: 'A Website show the Event Management & Decoration ideas and images',
        technologies: ['HTML', 'CSS', 'JavaScript'],
        link: 'https://aaiji-decoration.com',
      },
    ],
    skills: ['JavaScript', 'React', 'Node.js'],
    extraFields: {
      github: 'https://github.com/shubhammukati',
      linkedin: 'https://linkedin.com/in/shubhammukati',
    },
  });

  const handleChange = (e, field) => {
    setResume({ ...cvData, [field]: e.target.value });
  };

  const handleNestedChange = (e, field, index, subField) => {
    const updatedField = [...cvData[field]];
    updatedField[index] = { ...updatedField[index], [subField]: e.target.value };
    setResume({ ...cvData, [field]: updatedField });
  };

  const handleArrayChange = (e, field, index) => {
    const updatedField = [...cvData[field]];
    updatedField[index] = e.target.value;
    setResume({ ...cvData, [field]: updatedField });
  };

  const addEntry = (field) => {
    const newEntry =
      field === 'experience'
        ? { title: '', company: '', startDate: '', endDate: '', description: '' }
        : field === 'education'
        ? { degree: '', institution: '', startDate: '', endDate: '' }
        : field === 'projects'
        ? { title: '', description: '', technologies: [], link: '' }
        : '';
    setResume({ ...cvData, [field]: [...cvData[field], newEntry] });
  };

  const removeEntry = (field, index) => {
    const updatedField = cvData[field].filter((_, i) => i !== index);
    setResume({ ...cvData, [field]: updatedField });
  };

  const handleSaveAsPDF = () => {
    const element = componentRef.current;
    const pdf = new jsPDF({
      orientation: 'portrait',
      unit: 'mm',
      format: 'a4',
    });

    pdf.html(element, {
      callback: function (pdf) {
        pdf.save('cvData.pdf');
      },
      x: 10,
      y: 10,
      width: 180, // Reduce width slightly to improve rendering
      windowWidth: 800, // Reduce excessive scaling for better speed
    });
  };

  // Save draft API request
  const handleSaveDraft = async () => {
    try {
      const response = await axios.post(
        'https://ai-powered-cv-maker-api.vercel.app/api/draft/save-draft/67ab39cb0000f2df3bd0aa01',
        { cvData }, // Wrapped inside an object to match API format
        { headers: { 'Content-Type': 'application/json' } }
      );
      console.log('Response', response);

      if (response.status === 200) {
        alert('Draft saved successfully!');
      } else {
        alert('Failed to save draft.');
      }
    } catch (error) {
      console.error('Error saving draft:', error);
      alert(
        `An error occurred while saving the draft: ${
          error.response?.data?.message || error.message
        }`
      );
    }
  };

  return (
    <Container className="mt-4" style={{}}>
      <Row>
        <Col md={6}>
          <Card>
            <Card.Body>
              <h4>Edit Resume</h4>

              {/* Edit Name */}
              <Form.Group className="mb-3">
                <Form.Label>Name</Form.Label>
                <Form.Control
                  type="text"
                  value={cvData.name}
                  onChange={(e) => handleChange(e, 'name')}
                />
              </Form.Group>
              <hr />

              {/* Edit Title */}
              <Form.Group className="mb-3">
                <Form.Label>Title</Form.Label>
                <Form.Control
                  type="text"
                  value={cvData.title}
                  onChange={(e) => handleChange(e, 'title')}
                />
              </Form.Group>
              <hr />

              {/* Edit Phone Number */}
              <Form.Group className="mb-3">
                <Form.Label>Phone Number</Form.Label>
                <Form.Control
                  type="text"
                  value={cvData.phoneNumber}
                  onChange={(e) => handleChange(e, 'phoneNumber')}
                />
              </Form.Group>
              <hr />

              {/* Edit Email */}
              <Form.Group className="mb-3">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="text"
                  value={cvData.email}
                  onChange={(e) => handleChange(e, 'email')}
                />
              </Form.Group>
              <hr />

              {/* Edit Location */}
              <Form.Group className="mb-3">
                <Form.Label>Location</Form.Label>
                <Form.Control
                  type="text"
                  value={cvData.location}
                  onChange={(e) => handleChange(e, 'location')}
                />
              </Form.Group>
              <hr />

              {/* Edit Summary */}
              <Form.Group className="mb-3">
                <Form.Label>Summary</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  value={cvData.summary}
                  onChange={(e) => handleChange(e, 'summary')}
                />
              </Form.Group>
              <hr />

              {/* Edit Experience */}
              <h5>Experience</h5>
              {cvData.experience.map((exp, index) => (
                <div key={index} className="mb-3">
                  <Form.Group>
                    <Form.Label>Title</Form.Label>
                    <Form.Control
                      type="text"
                      value={exp.title}
                      onChange={(e) => handleNestedChange(e, 'experience', index, 'title')}
                    />
                  </Form.Group>
                  <Form.Group>
                    <Form.Label>Company</Form.Label>
                    <Form.Control
                      type="text"
                      value={exp.company}
                      onChange={(e) => handleNestedChange(e, 'experience', index, 'company')}
                    />
                  </Form.Group>
                  <Form.Group>
                    <Form.Label>Start Date</Form.Label>
                    <Form.Control
                      type="text"
                      value={exp.startDate}
                      onChange={(e) => handleNestedChange(e, 'experience', index, 'startDate')}
                    />
                  </Form.Group>
                  <Form.Group>
                    <Form.Label>End Date</Form.Label>
                    <Form.Control
                      type="text"
                      value={exp.endDate}
                      onChange={(e) => handleNestedChange(e, 'experience', index, 'endDate')}
                    />
                  </Form.Group>
                  <Form.Group>
                    <Form.Label>Description</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={2}
                      value={exp.description}
                      onChange={(e) => handleNestedChange(e, 'experience', index, 'description')}
                    />
                  </Form.Group>
                  <Button
                    variant="danger"
                    size="sm"
                    onClick={() => removeEntry('experience', index)}
                  >
                    Remove
                  </Button>
                  <hr />
                </div>
              ))}
              <Button onClick={() => addEntry('experience')} className="mb-3">
                Add Experience
              </Button>
              <hr />

              {/* Edit Education */}
              <h5>Education</h5>
              {cvData.education.map((edu, index) => (
                <div key={index} className="mb-3">
                  <Form.Group>
                    <Form.Label>Degree</Form.Label>
                    <Form.Control
                      type="text"
                      value={edu.degree}
                      onChange={(e) => handleNestedChange(e, 'education', index, 'degree')}
                    />
                  </Form.Group>
                  <Form.Group>
                    <Form.Label>Institution</Form.Label>
                    <Form.Control
                      type="text"
                      value={edu.institution}
                      onChange={(e) => handleNestedChange(e, 'education', index, 'institution')}
                    />
                  </Form.Group>
                  <Form.Group>
                    <Form.Label>Start Date</Form.Label>
                    <Form.Control
                      type="text"
                      value={edu.startDate}
                      onChange={(e) => handleNestedChange(e, 'education', index, 'startDate')}
                    />
                  </Form.Group>
                  <Form.Group>
                    <Form.Label>End Date</Form.Label>
                    <Form.Control
                      type="text"
                      value={edu.endDate}
                      onChange={(e) => handleNestedChange(e, 'education', index, 'endDate')}
                    />
                  </Form.Group>
                  <Button
                    variant="danger"
                    size="sm"
                    onClick={() => removeEntry('education', index)}
                  >
                    Remove
                  </Button>
                  <hr />
                </div>
              ))}
              <Button onClick={() => addEntry('education')} className="mb-3">
                Add Education
              </Button>
              <hr />

              {/* Edit Projects */}
              <h5>Projects</h5>
              {cvData.projects.map((proj, index) => (
                <div key={index} className="mb-3">
                  <Form.Group>
                    <Form.Label>Title</Form.Label>
                    <Form.Control
                      type="text"
                      value={proj.title}
                      onChange={(e) => handleNestedChange(e, 'projects', index, 'title')}
                    />
                  </Form.Group>
                  <Form.Group>
                    <Form.Label>Description</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={2}
                      value={proj.description}
                      onChange={(e) => handleNestedChange(e, 'projects', index, 'description')}
                    />
                  </Form.Group>
                  <Form.Group>
                    <Form.Label>Technologies</Form.Label>
                    <Form.Control
                      type="text"
                      value={proj.technologies.join(', ')}
                      onChange={(e) => {
                        const updatedTechnologies = e.target.value.split(', ');
                        const updatedProjects = [...cvData.projects];
                        updatedProjects[index] = {
                          ...updatedProjects[index],
                          technologies: updatedTechnologies,
                        };
                        setResume({ ...cvData, projects: updatedProjects });
                      }}
                    />
                  </Form.Group>
                  <Form.Group>
                    <Form.Label>Link</Form.Label>
                    <Form.Control
                      type="text"
                      value={proj.link}
                      onChange={(e) => handleNestedChange(e, 'projects', index, 'link')}
                    />
                  </Form.Group>
                  <Button
                    variant="danger"
                    size="sm"
                    onClick={() => removeEntry('projects', index)}
                  >
                    Remove
                  </Button>
                  <hr />
                </div>
              ))}
              <Button onClick={() => addEntry('projects')} className="mb-3">
                Add Project
              </Button>
              <hr />

              {/* Edit Skills */}
              <h5>Skills</h5>
              {cvData.skills.map((skill, index) => (
                <Form.Group key={index} className="mb-3">
                  <Form.Control
                    type="text"
                    value={skill}
                    onChange={(e) => handleArrayChange(e, 'skills', index)}
                  />
                </Form.Group>
              ))}
              <Button onClick={() => setResume({ ...cvData, skills: [...cvData.skills, ''] })}>
                Add Skill
              </Button>
              <hr />

              {/* Edit Extra Fields */}
              <h5>Extra Fields</h5>
              <Form.Group className="mb-3">
                <Form.Label>GitHub</Form.Label>
                <Form.Control
                  type="text"
                  value={cvData.extraFields.github}
                  onChange={(e) => {
                    const updatedExtraFields = { ...cvData.extraFields, github: e.target.value };
                    setResume({ ...cvData, extraFields: updatedExtraFields });
                  }}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>LinkedIn</Form.Label>
                <Form.Control
                  type="text"
                  value={cvData.extraFields.linkedin}
                  onChange={(e) => {
                    const updatedExtraFields = { ...cvData.extraFields, linkedin: e.target.value };
                    setResume({ ...cvData, extraFields: updatedExtraFields });
                  }}
                />
              </Form.Group>
              <hr />

              {/* Save as PDF */}
              <Button onClick={handleSaveAsPDF} variant="secondary" className="mt-2 w-100">
                Save as PDF
              </Button>

              {/* Save as Draft */}
              <Button onClick={handleSaveDraft} variant="success" className="mt-2 w-100">
                Save as Draft
              </Button>
            </Card.Body>
          </Card>
        </Col>

        {/* Resume Preview */}
        <Col md={6}>
          <div
            ref={componentRef}
            className="p-4 border rounded"
            style={{
              backgroundColor: '#f9f9f9',
              maxWidth: '210mm', // A4 width
              margin: '0 auto', // Center the content
              fontSize: '10px', // Adjust font size to fit content
              overflow: 'hidden', // Ensure no overflow
            }}
          >
            {/* Header Section */}
            <div className="text-center mb-4" style={{ backgroundColor: '#007bff', color: '#fff', padding: '10px', borderRadius: '10px' }}>
              <h1 style={{ fontSize: '18px' }}>{cvData.name}</h1>
              <h3 style={{ fontSize: '14px' }}>{cvData.title}</h3>
              <p style={{ fontSize: '12px' }}>
                {cvData.phoneNumber} | {cvData.email} | {cvData.location}
              </p>
            </div>

            {/* Summary Section */}
            <div className="mb-4">
              <h4 style={{ color: '#007bff', fontSize: '14px' }}>SUMMARY</h4>
              <p style={{ fontSize: '12px' }}>{cvData.summary}</p>
            </div>

            {/* Experience Section */}
            <div className="mb-4">
              <h4 style={{ color: '#007bff', fontSize: '14px' }}>EXPERIENCE</h4>
              {cvData.experience.map((exp, index) => (
                <div key={index} className="mb-3">
                  <h5 style={{ color: '#28a745', fontSize: '12px' }}>
                    {exp.title} - {exp.company}
                  </h5>
                  <p style={{ fontSize: '12px' }}>
                    {exp.startDate} - {exp.endDate}
                  </p>
                  <p style={{ fontSize: '12px' }}>{exp.description}</p>
                </div>
              ))}
            </div>

            {/* Education Section */}
            <div className="mb-4">
              <h4 style={{ color: '#007bff', fontSize: '14px' }}>EDUCATION</h4>
              {cvData.education.map((edu, index) => (
                <div key={index} className="mb-3">
                  <h5 style={{ color: '#28a745', fontSize: '12px' }}>{edu.degree}</h5>
                  <p style={{ fontSize: '12px' }}>
                    {edu.institution} | {edu.startDate} - {edu.endDate}
                  </p>
                </div>
              ))}
            </div>

            {/* Projects Section */}
            <div className="mb-4">
              <h4 style={{ color: '#007bff', fontSize: '14px' }}>PROJECTS</h4>
              {cvData.projects.map((proj, index) => (
                <div key={index} className="mb-3">
                  <h5 style={{ color: '#28a745', fontSize: '12px' }}>{proj.title}</h5>
                  <p style={{ fontSize: '12px' }}>{proj.description}</p>
                  <p style={{ fontSize: '12px' }}>Technologies: {proj.technologies.join(', ')}</p>
                  <p style={{ fontSize: '12px' }}>Link: {proj.link}</p>
                </div>
              ))}
            </div>

            {/* Skills Section */}
            <div className="mb-4">
              <h4 style={{ color: '#007bff', fontSize: '14px' }}>SKILLS</h4>
              <ul style={{ fontSize: '12px' }}>
                {cvData.skills.map((skill, index) => (
                  <li key={index}>{skill}</li>
                ))}
              </ul>
            </div>

            {/* Extra Fields Section */}
            <div className="mb-4">
              <h4 style={{ color: '#007bff', fontSize: '14px' }}>EXTRA FIELDS</h4>
              <p style={{ fontSize: '12px' }}>GitHub: {cvData.extraFields.github}</p>
              <p style={{ fontSize: '12px' }}>LinkedIn: {cvData.extraFields.linkedin}</p>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default Cvthemeone;